import i18n from '@/i18n'

export default {
    leader: i18n.t('values.network.types.leader'),
    team: i18n.t('values.network.types.team'),
    peer: i18n.t('values.network.types.peer'),
}
